export interface ParentReferenceSeed {
    isNew: boolean;
    parentResourceType?: string;
    parentResourceId?: string;
}

/**
 * For a NEW relationship record (one created as a child of a parent record, e.g.
 * an object_template_attribute under an object_template), seed the parent
 * foreign-key (`${parentResourceType}_id`) into the form's initial values.
 *
 * Why: submitRelationshipRecordForm already injects `${parentResourceType}_id`
 * into the mutation variables at submit time, but NOT into the form `values` the
 * user edits. A field component that needs to know its parent *while the form is
 * open* (before the first save) — e.g. the INCOMING_REFERENCE attribute editor,
 * which lists the back-references that point at the template being edited — would
 * otherwise see no parent id until the record is saved. Seeding it here is
 * consistent with what is submitted, so it does not change create semantics.
 *
 * Only applied for new records: an existing record already carries the parent FK
 * in its fetched data (initialValues), so nothing is overwritten.
 */
export const seedParentReferenceInitialValues = (
    base: Record<string, unknown> | undefined,
    { isNew, parentResourceType, parentResourceId }: ParentReferenceSeed
): Record<string, unknown> | undefined => {
    if (isNew && parentResourceType && parentResourceId) {
        return { ...(base || {}), [`${parentResourceType}_id`]: parentResourceId };
    }
    return base;
};
